<template>
    <div class="dialog-wrapper">
        <el-dialog title="这里是登录弹窗" :visible.sync="dialogVisible" width="360px" :before-close="handleClose"
            append-to-body>
            <!-- <el-row>
                <div class="info"></div>
            </el-row> -->
            <el-row class="m-b-17px" v-show="currentPage === 'login'">
                <span class="purple pointer purple-background m-l-268px" @click="currentPage = 'register'">去注册</span>
            </el-row>
            <!-- 登录 -->
            <el-row v-show="currentPage === 'login'">
                <el-row class="m-b-17px">
                    <h1>欢迎使用字由</h1>
                </el-row>
                <el-tabs v-model="activeName" class="m-l-40px">
                    <el-tab-pane label="手机号" name="first">
                        <el-input class="login-input" v-model="loginParams['phone']" placeholder="请输入您的手机号"></el-input>
                    </el-tab-pane>
                    <el-tab-pane label="邮箱" name="second">
                        <el-input class="login-input" v-model="loginParams['email']" placeholder="请输入邮箱"></el-input>
                    </el-tab-pane>
                </el-tabs>
                <el-input class="login-input m-t-12px m-l-40px" v-model="loginParams['password']" placeholder="请输入密码"
                    type="password">
                </el-input>
                <div class="next flex align-center justify-center pointer" :class="isActive ? 'active' : ''"
                    @click="loginFn">下一步</div>
                <el-row class="m-l-40px gray-text">注册即视为同意字由用户协议及字由隐私协议</el-row>
            </el-row>
            <!-- 注册 -->
            <el-row v-show="currentPage === 'register'">
                <el-row class="pointer m-l-40px m-b-17px"><span @click="currentPage = 'login'">&lt; 返回</span></el-row>
                <el-row>
                    <h1>欢迎注册字由</h1>
                </el-row>
                <el-row>
                    <el-input class="login-input m-l-40px m-t-12px" v-model="registerParams['phone']"
                        placeholder="请输入你的手机号" maxlength="11"></el-input>
                    <span class="purple pointer" :class="isCountdown ? 'm-l-25px' : 'm-l-70px'" @click="CountdownFn">{{
                            isCountdown ? time : '获取验证码'
                    }}</span>
                </el-row>
                <el-row class="flex align-center m-l-40px m-t-12px">
                    <el-input class="code" v-model="registerParams['verificationCode'][0]" maxlength="1"></el-input>
                    <div class="line"></div>
                    <el-input class="code" v-model="registerParams['verificationCode'][1]" maxlength="1"></el-input>
                    <div class="line"></div>
                    <el-input class="code" v-model="registerParams['verificationCode'][2]" maxlength="1"></el-input>
                    <div class="line"></div>
                    <el-input class="code" v-model="registerParams['verificationCode'][3]" maxlength="1"></el-input>
                </el-row>
                <el-row class="tips m-l-40px m-t-7px" v-if="isCountdown">
                    已发送4位验证码至手机，有效期10分钟，如未收到，请尝试重新获取验证码
                </el-row>
                <div class="next flex align-center justify-center"
                    :class="(checked && registerParams['verificationCode'].length === 4) ? 'active' : ''"
                    @click="message('验证码错误')">注册</div>
                <el-row class="m-l-47px">
                    <el-checkbox v-model="checked"></el-checkbox>
                    <span class="gray-text m-l-6px">我已阅读并同意 <span class="purple">字由用户协议</span> 及 <span
                            class="purple">字由隐私协议</span></span>
                </el-row>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'login-dialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            time: 60,
            isCountdown: false,
            checked: false,
            currentPage: 'login',
            dialogVisible: true,
            activeName: 'first',
            loginParams: {
                phone: '',
                password: '',
                email: ''
            },
            registerParams: {
                phone: '',
                verificationCode: []
            }
        }
    },
    watch: {
        visible: {
            handler(newVal) {
                this.dialogVisible = newVal
            },
            immediate: true
        },
    },
    computed: {
        isActive() {
            if (this.activeName === 'first') {
                return !!this.loginParams['password'] && !!this.loginParams['phone']
            }
            if (this.activeName === 'second') {
                return !!this.loginParams['password'] && !!this.loginParams['email']
            }
            return false
        }
    },
    methods: {
        handleClose() {
            this.dialogVisible = false
            this.$emit('update:visible', false)
        },
        CountdownFn() {
            if (this.registerParams['phone'].length !== 11) {
                this.$message('请输入完整的手机号');
                return
            }
            if (this.isCountdown) return
            this.$message('已发送验证码，请注意查收');
            this.isCountdown = true
            let timer = setInterval(() => {
                if (this.time > 1) this.time--
                else {
                    this.time = 60
                    this.isCountdown = false
                    clearInterval(timer)
                }
            }, 1000)
        },
        message(message) {
            if (!(this.checked && this.registerParams['verificationCode'].length === 4)) return
            this.$message(message);
        },
        loginFn() {
            if (!this.isActive) return
            this.$message('账号名或密码错误')
        }
    }
}
</script>

<style lang="less" scoped>
:deep(.el-dialog__header) {
    display: none !important;
    ;
}

:deep(.el-dialog__body) {
    width: 360px;
    margin: 0 !important;
    padding: 0 !important;
    padding-bottom: 42px !important;
    padding-top: 15px !important;
}

.pointer {
    cursor: pointer;
}

.flex {
    display: flex;
}

.align-center {
    align-items: center;
}

.justify-center {
    justify-content: center;
}

.info {
    width: 12px;
    height: 12px;
    background: rgba(254, 114, 88, 1);
    border-radius: 50%;
    margin-left: 10px;
    margin-top: 10px;
    margin-bottom: 15px;
}

h1 {
    font-size: 22px;
    font-weight: 500;
    letter-spacing: 0.44px;
    line-height: 31px;
    color: rgba(59, 57, 72, 1);
    text-align: left;
    vertical-align: top;
    margin-left: 40px;
}

:deep(.el-tabs__nav-wrap::after) {
    background: white !important;
}

.next {
    width: 280px;
    height: 44px;
    background: #9AAEF8;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 24px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    vertical-align: top;
    margin-left: 40px;
    margin-top: 60px;
    margin-bottom: 10px;
}

.purple {
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 0px;
    color: rgba(85, 118, 242, 1);
}

.purple-background {
    padding: 3px 8px 3px 8px;
    height: 24px;
    border-radius: 16px;
    background: #ECF0FD;
}

.login-input {
    width: 280px;
    margin: 0 auto;
    position: relative;
}

.m-t-12px {
    margin-top: 12px;
}

.m-t-7px {
    margin-top: 7px;
}

.m-l-40px {
    margin-left: 40px;
}

.m-l-47px {
    margin-left: 47px;
}

.m-l-70px {
    margin-left: -70px;
    position: relative;
}

.m-l-25px {
    margin-left: -25px;
    position: relative;
}

.m-l-6px {
    margin-left: 6px;
}

.m-l-268px {
    margin-left: 268px;
}

.m-b-17px {
    margin-bottom: 17px;
}

.gray-text {
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 18px;
    color: rgba(151, 150, 157, 1);
}

.code {
    width: 44px;
    border-radius: 6px;
}

.line {
    width: 10px;
    height: 1px;
    background: #DCDFE6;
    margin-left: 13px;
    margin-right: 13px;
}

.tips {
    width: 273px;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 17px;
    color: rgba(151, 150, 158, 1);
    text-align: left;
    vertical-align: top;
}

.active {
    background: #5777F2;
}
</style>